import React, { useState, useEffect } from "react";
import styles from "./PopUpEinwilligung.module.css";
import Button from "@mui/material/Button";

function PopupEinwilligung({ children }) {
  const [consent, setConsent] = useState(() => {
    const saved = localStorage.getItem("user_consent");
    return saved === "true" ? true : saved === "false" ? false : null;
  });

  useEffect(() => {
    if (consent === false) {
      Object.keys(localStorage).forEach((key) => {
        if (key !== "user_consent") {
          localStorage.removeItem(key);
        }
      });
    }
  }, [consent]);

  const handleConsent = (value) => {
    setConsent(value);
    localStorage.setItem("user_consent", value);
    if (!value) {
      Object.keys(localStorage).forEach((key) => {
        if (key !== "user_consent") {
          localStorage.removeItem(key);
        }
      });
    }
  };

  useEffect(() => {
    document.body.style.overflow = consent === null ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [consent]);

  return (
    <>
      {consent === null && (
        <div className={styles.cookieOverlay}>
          <div className={styles.cookiePopup}>
            <h2 className={styles.cookieTitle}>
              Einwilligung zur Datenspeicherung
            </h2>
            <p className={styles.cookieText}>
              Wir speichern deine Angaben im LocalStorage deines Browsers, um
              dir das Ausfüllen zu erleichtern. Bei weiteren Fragen lies bitte
              unsere <a href="/datenschutzerklaerung">Datenschutzerklärung</a>{" "}
              und <a href="/agb">AGB</a>.
            </p>
            <Button
              id={styles.cookieBtnPrimary}
              onClick={() => handleConsent(true)}
              fullWidth
              disableElevation
              variant="contained"
            >
              Akzeptieren
            </Button>
            <button
              className={styles.cookieLink}
              onClick={() => handleConsent(false)}
            >
              Sorry, heute lieber nicht.
            </button>
          </div>
        </div>
      )}

      <div
        style={
          consent === null
            ? { filter: "blur(4px)", pointerEvents: "none", userSelect: "none" }
            : {}
        }
      >
        {children}
      </div>
    </>
  );
}

export default PopupEinwilligung;
